import React, { createContext, FC } from 'react'
import { authLink, cache, uploadHttpLink } from '@src/global'
import { ApolloClient, ApolloLink } from '@apollo/client'
import { ApolloProvider as ApolloClientProvider } from '@apollo/client/react'
interface ApolloContextProps {
  client?: ApolloClient
}

interface ApolloProviderProps {
  children?: React.ReactNode
}

export const ApolloContext = createContext<ApolloContextProps>({})

export const ApolloProvider: FC<ApolloProviderProps> = ({ children }) => {
  const client = new ApolloClient({
    cache,
    link: ApolloLink.from([authLink, uploadHttpLink]),
  })

  return <ApolloClientProvider client={client}>{children}</ApolloClientProvider>
}
